/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Related_ServicesInputs */

const en_directory_related_services = /** @type {(inputs: Directory_Related_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related services`)
};

const pl_directory_related_services = /** @type {(inputs: Directory_Related_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podobne usługi`)
};

/**
* | output |
* | --- |
* | "Related services" |
*
* @param {Directory_Related_ServicesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_related_services = /** @type {((inputs?: Directory_Related_ServicesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Related_ServicesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_related_services(inputs)
	return en_directory_related_services(inputs)
});